<template>
  <div
    class="loading-component show-on-load"
    :class="`loading-component--${rendering?.componentName.toLowerCase()}`"
  >
    <loading-spinner />
  </div>
</template>

<script setup>
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner.vue';

defineProps({
  rendering: {
    type: Object,
  },
});

defineOptions({
  inheritAttrs: false,
});
</script>

<style lang="scss">
@import './scss/LoadingComponent.scss';
</style>
